import type { FC, SVGProps } from "react";

const IconPoolIncluded: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M18 1C17.4696 1 16.9609 1.21071 16.5858 1.58579C16.2107 1.96086 16 2.46957 16 3V14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 14C1.6 14.5 2.2 15 3.5 15C6 15 6 13 8.5 13C11.1 13 10.9 15 13.5 15C16 15 16 13 18.5 13C19.8 13 20.4 13.5 21 14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 9H16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 5H16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 1C7.46957 1 6.96086 1.21071 6.58579 1.58579C6.21071 1.96086 6 2.46957 6 3V14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconPoolIncluded;
